<footer class="min-h-[100px] bg-card">
  <app-container>
    <div class="py-5">
      <app-card>
        <app-card-body>
          <div class="[&_a]:underline hover:[&_a]:no-underline">
            <p>
              "<a routerLink="/">Интересное на {{ environment.websiteName }}</a>". Все права защищены 2014-{{ year }}
            </p>
            <p>
              <a [routerLink]="['/', r.blogs]">Новости</a> ·
              <a [routerLink]="['/', r.catNested]">Разделы</a> ·
              <a [routerLink]="['/', r.tags]">Теги</a> ·
              <a [routerLink]="['/', r.donate]">Поддержать</a>
            </p>
          </div>
        </app-card-body>

      </app-card>
    </div>

  </app-container>
</footer>
